import React from 'react';
// import { Link } from 'react-router-dom';

import imgixConfig from 'Config/imgix';

export default function StaticBannerOffer() {
  const imgSrcMobile = 'https://fanatical.imgix.net/production/assets/banners/birthday-mystery-bundle-competition.jpg';

  return (
    <div className="offer-banner preorder-bonus-banner-img">
      <div className="StaticBannerOffer">
        <img
          srcSet={`
            ${imgSrcMobile}?${imgixConfig}&w=1292&h=340&fit=crop 1292w,
            ${imgSrcMobile}?${imgixConfig}&w=704&h=185&fit=crop 704w,
            ${imgSrcMobile}?${imgixConfig}&w=646&h=170&fit=crop 646w,
            ${imgSrcMobile}?${imgixConfig}&w=578&h=144&fit=crop 578w,
            ${imgSrcMobile}?${imgixConfig}&w=524&h=138&fit=crop 524w,
            ${imgSrcMobile}?${imgixConfig}&w=460&h=121&fit=crop 460w
          `}
          sizes="(min-width: 1520px) 646px, (min-width: 1200px) 578px, (min-width: 992px) 460px, (min-width: 768px) 704px, (min-width: 576px) 524px, 95vw"
          src={`${imgSrcMobile}?${imgixConfig}&w=646&h=170&fit=crop`}
          alt="Buy the Birthday Mystery Bundle for a chance to win 1 of 5 epic prizes! | T&Cs apply"
        />
      </div>
    </div>
  );
}
